<template>
  <Card title="Turmas Aguardando Processamento" description="Relatório de Turmas com Status de Aguardando Processamento (Detran)" icon="ion ion-ios-document">
    <button @click="getAulasAguardandoProcessamento()" v-if='!download.load' class="btn btn-block btn-lg btn-secondary">GERAR</button>
    <div v-else class="d-flex justify-content-center">
      <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
      </div>
    </div>
  </Card>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApiV2'
import Card from '../../../cards/card.vue';

export default {
  name: 'aulasAguardandoProcessamento',
  components: {
    ...spinners,
    Card,
  },
  data () {
    return {
      download: {
        load: false
      },
    }
  },
  methods: {
    getAulasAguardandoProcessamento () {
        this.download.load = true

        this.$http.get(urlApi + '/turmas/relatorio/teoricas/status/aguardandoprocessamento').then(this.downloadPDF)
    },
    downloadPDF (response) {
        if (response.data.sucesso) {
          var pdf = "data:application/octet-stream;base64," + response.data.dados;
					var downloadPDF = document.getElementById("downloadPDF");
					downloadPDF.download = "relatorio de turmas aguardando processamento.pdf";
					downloadPDF.href = pdf;
          downloadPDF.click();
          this.download.load = false;
        } else {
          this.$toasted.show('Consulta não possui resultado', {
            position: 'top-right',
          })
          this.download.load = false;
        }
      },
  }
}
</script>

<style>

</style>
